import React from 'react';
import { NewsArticleHeader, NewsArticleContent } from '@leasen_nl/listo/src/components/news';
import SocialMedia from './atoms';

const NewsArticlePage = () => (
  <>
    <NewsArticleHeader />
    <NewsArticleContent />
    <SocialMedia />
  </>
);

export default NewsArticlePage;
